"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.EditorialCardsOptionsDefaultProps = exports.EditorialCardsDefaultProps = exports.EditorialCards = void 0;

var _editorialCards = _interopRequireDefault(require("./components/editorial-cards"));

exports.EditorialCards = _editorialCards["default"];

var _editorialCards2 = _interopRequireDefault(require("./components/editorial-cards.props/editorial-cards.defaultProps"));

exports.EditorialCardsDefaultProps = _editorialCards2["default"];

var _editorialCardsOptions = _interopRequireDefault(require("./components/editorial-cards.props/editorial-cards.options.defaultProps"));

exports.EditorialCardsOptionsDefaultProps = _editorialCardsOptions["default"];